import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import ModalOverlay from './../ModalOverlay.jsx';
import { MediaContext } from '../../MediaContext';
import './ComposableVideo.css';
import I18NextContext from '../../i18next-context/I18NextContext.jsx';
import { giftingVideoId } from '../../../../utils/StaticAssetManager.js';
import { Button } from 'web-store-modules/packages/web-store-ui-library';
import { withTranslation } from 'react-i18next';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import { getAllSceneInfoDictAsync } from '../../../../utils/StoreConfigManager.js';

const cdnUrl = `https://cdn.obsess-vr.com/ferragamo/`

const ComposableVideo = ({ hotspotId, src, style, videoMuted = false, t }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [videoSrc, setVideoSrc] = useState(src);
    const { currentLanguage } = useContext(I18NextContext);
    const mediaContext = useContext(MediaContext);
    const { history, pushHistoryWithReset } = useContext(ThreeJSWorldContext);

    useEffect(() => {
        if (hotspotId === giftingVideoId) {
            const giftSrc = cdnUrl + (currentLanguage == 'ita_it' ? '20211109_FERRAGAMO_RICETTA_ITL.mp4' : currentLanguage == 'jpn_ja' ? '20211112_FERRAGAMO_RICETTA_JAP.mp4' : currentLanguage == 'fra_fr' ? '20211112_FERRAGAMO_RICETTA_FRA.mp4' : (currentLanguage == 'eu_de' || currentLanguage == 'eu_en') ? '20211112_FERRAGAMO_RICETTA_GER.mp4' : '20211112_FERRAGAMO_RICETTA_UK.mp4')
            console.log({ giftSrc });
            setVideoSrc(giftSrc)
        }

        mediaContext.setIsVideoPlaying(true);
        return mediaContext.setIsVideoPlaying(false);
    }, []);

    const onPlay = () => {
        mediaContext.setIsVideoPlaying(true);
        setIsPlaying(true);
    };

    const onPause = () => {
        setIsPlaying(false);
    };

    const onStartLoad = () => {
        setIsLoading(true)
    }

    const onEndLoad = () => {
        setIsLoading(false)
    }

    const extraVideoContent = () => {
        return (
            <div className="button-video-container">
                <div className="video-text">{`${t('videoGiftText')}`}</div>
            </div>
        )
    }

    const handleClick = () => {
        const sceneId = '61773f0a64cca322c1f89d54' //projection-2 sceneId
        getAllSceneInfoDictAsync()
            .then(sceneInfoDict => {
                if (!sceneInfoDict[sceneId]) {
                    throw new Error('Scene with id ' + sceneId + ' do not exist!');
                }

                const linkedSceneName = sceneInfoDict[sceneId]['name'];
                let targetPath = `/${currentLanguage}/${linkedSceneName}`;

                if (history.location.pathname !== targetPath) {
                    pushHistoryWithReset(targetPath)
                }
            })
    }

    const ctaButton = () => {
        return (
            <div className="button-video-container">
                <div className="video-button"><Button
                    hoverStyleChange={true}
                    primaryColor='#000'
                    secondaryColor='#c8bda9'
                    onClick={handleClick}
                    className="text-marker-button flex-center obsessvr-regularFont pointer product-button"
                    style={{ padding: '0', margin: '0 1%', height: '100%'}}
                    primaryBorderColor='white'
                    secondaryBorderColor='white'
                    primaryBorderWidth='0px'
                    secondaryBorderWidth='0px'
                    insetBorder={true}
                    padded={false}
                >
                    <p className='obsessvr-regularFont' style={{fontFamily: 'MessinaSans-Semibold', textTransform: 'uppercase', whiteSpace: 'nowrap', fontSize:'12px'}}>
                        {`${t('videoGiftCtaBtn')}`}
                    </p>
                </Button></div>
            </div>
        )
    }

    return (
        <div className={isPlaying ? 'composableVideoPlaying' : ''}>
            <ModalOverlay />
            {hotspotId === giftingVideoId && extraVideoContent()}
            <video
                controls
                autoPlay
                muted={videoMuted}
                playsInline={true}
                preload='auto'
                style={style}
                onPlay={onPlay}
                onPause={onPause}
                onLoadStart={onStartLoad}
                onLoadedData={onEndLoad}
                width={isLoading ? '0' : 'auto'}>
                <source src={videoSrc} />
            </video>
            {hotspotId === giftingVideoId && ctaButton()}
        </div>
    );
}

ComposableVideo.propTypes = {
    src: PropTypes.string.isRequired,
    style: PropTypes.object
};

export default withTranslation()(ComposableVideo);